import React from 'react'
import { css, cx } from '@emotion/css'
import { codeCss } from '../text'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { FormattedMessage } from 'react-intl'
import { CopyButton } from '../../design-system'
import { logSuccess } from '../../components/toaster'
import { ContrastFormattedMessage } from '../../components/contrast-formatted-message'

export interface CodeSnippetProps {
  readonly allowCopy?: boolean
  readonly children: React.ReactNode
  readonly className?: string
  readonly labelClassName?: string
  readonly copyContent?: string
  readonly copySuccessMessageId?: string
  readonly labelId?: string
  readonly childContainerClassName?: string
  readonly onCopy?: () => void
  dataTestId?: string
}

export const codeSnippetCss = cx(
  css`
    background-color: ${theme.color.neutral20};
    white-space: pre-wrap;
    word-break: break-all;
  `,
  codeCss
)

export function CodeSnippet({
  allowCopy,
  children,
  className,
  labelClassName,
  copyContent,
  copySuccessMessageId,
  labelId,
  childContainerClassName,
  onCopy,
  dataTestId
}: CodeSnippetProps) {
  if (allowCopy && !copySuccessMessageId) {
    throw new Error(
      'copySuccessMessageId prop is required if allowCopy is true'
    )
  }
  return (
    <div data-testid={dataTestId}>
      {labelId && (
        <FormattedMessage
          id={labelId}
          children={(label) => <div className={labelClassName}>{label}</div>}
        />
      )}
      <div
        className={cx(
          'legend-ds-code-snippet',
          css`
            margin-top: 5px;
            padding: 10px 15px;
            width: 100%;
          `,
          codeSnippetCss,
          className
        )}
      >
        <div
          className={cx(
            css`
              margin-right: 15px;
            `,
            childContainerClassName
          )}
        >
          {children}
        </div>
        {allowCopy && copyContent && copySuccessMessageId && (
          <div
            className={css`
              vertical-align: top;
              display: flex;
            `}
          >
            <ContrastFormattedMessage id={copySuccessMessageId}>
              {(copiedMsg) => (
                <CopyButton
                  stringToCopy={copyContent}
                  onClick={() => {
                    if (onCopy) {
                      onCopy()
                    }
                    logSuccess(copiedMsg)
                  }}
                />
              )}
            </ContrastFormattedMessage>
          </div>
        )}
      </div>
    </div>
  )
}
